import React from 'react';

const MIN_DESCRIPTION_LENGTH = 80;

export function HangarListingChecklist({ gearDraft, gearCount = 0, editing = false }) {
  if (gearCount > 0 || editing) return null;

  const steps = [
    { label: 'Pick a category', done: Boolean(gearDraft.category) },
    { label: 'Name your item', done: Boolean(gearDraft.name?.trim()) },
    { label: 'Add a location', done: Boolean(gearDraft.location?.trim()) },
    { label: 'Set a daily price', done: Boolean(gearDraft.pricePerDay) },
    {
      label: 'Write a honest description',
      done: (gearDraft.description?.trim().length || 0) >= MIN_DESCRIPTION_LENGTH,
    },
    { label: 'Upload a main photo', done: Boolean(gearDraft.mainPicture || gearDraft.hasMainPicture) },
    {
      label: 'Add at least one available date range',
      done: gearDraft.dateRanges?.some((range) => range.startDate && range.endDate),
    },
  ];

  const completed = steps.filter((step) => step.done).length;

  return (
    <section className="hangar-checklist" aria-label="First listing checklist">
      <h3>Your first listing</h3>
      <p className="hangar-checklist-lead">
        No rush — work through the form below when you are ready. {completed} of {steps.length} steps
        started.
      </p>
      <ol className="hangar-checklist-steps">
        {steps.map((step) => (
          <li key={step.label} className={step.done ? 'is-done' : ''}>
            {step.label}
          </li>
        ))}
      </ol>
    </section>
  );
}